import React from 'react'
import PropTypes from 'prop-types'
import { CardNumberElement, CardExpiryElement, CardCVCElement, PostalCodeElement } from 'react-stripe-elements'
import './stripe.css'

const genericPropType = PropTypes.shape({
  onChange: PropTypes.func.isRequired,
}).isRequired

const createOptions = () => ({
  style: {
    base: {
      fontSize: '18px',
      letterSpacing: '0.025em',
      fontFamily: 'Source Code Pro, Menlo, monospace',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
  },
})


/**
 * @const renderStripeCardNumber
 * @param onChange
 */
export const renderStripeCardNumber = ({ input: { onChange } }) => (
    <CardNumberElement
      onChange={obj => onChange(obj.complete)}
      {...createOptions()}
    />
  )

renderStripeCardNumber.propTypes = {
  input: genericPropType
}


/**
 * @const renderStripeCardExpiry
 * @param onChange
 */
export const renderStripeCardExpiry = ({ input: { onChange } }) => (
  <CardExpiryElement
    onChange={obj => onChange(obj.complete)}
    {...createOptions()}
  />
)

renderStripeCardExpiry.propTypes = {
  input: genericPropType
}


/**
 * @const renderStripeCardCVC
 * @param onChange
 */
export const renderStripeCardCVC = ({ input: { onChange } }) => (
  <CardCVCElement
    onChange={obj => onChange(obj.complete)}
    {...createOptions()}
  />
)

renderStripeCardCVC.propTypes = {
  input: genericPropType
}


/**
 * @const renderStripeCardNumber
 * @param onChange
 */
export const renderStripePostalCode = ({ input: { onChange } }) => (
  <PostalCodeElement
    onChange={obj => onChange(obj.complete)}
    {...createOptions()}
  />
)

renderStripePostalCode.propTypes = {
  input: genericPropType
}

export default {
  renderStripeCardNumber,
  renderStripeCardExpiry,
  renderStripeCardCVC,
  renderStripePostalCode,
}



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderStripeCardElementInput.js